/**
 * Compute the variable cost multiplier from field costs.
 * - COMBO/enum/BOOLEAN: cost comes from extended_options[selectedValue].cost
 * - FLOAT/INT: cost is fieldDef.cost * currentValue (value multiplied by cost rate)
 * All collected cost values are multiplied together.
 * Returns 0 when no fields have cost values (no variable cost contribution).
 *
 * Final cost formula (applied externally):
 *   baseCost + (variableCostProduct * creditsPerUnit) + BASE_COST(6)
 */
export function computeVariableCostProduct(variables, currentValues) {
    if (!variables || !currentValues) return 0;
    const costValues = [];
    for (const [key, fieldDef] of Object.entries(variables)) {
        const type = fieldDef.type;
        let optionCost;

        if (type === 'COMBO' || type === 'enum' || type === 'COMFY_DYNAMICCOMBO_V3') {
            optionCost = fieldDef?.extended_options?.[currentValues[key]]?.cost;
        } else if (type === 'BOOLEAN' || type === 'bool' || type === 'BOOL' || type === 'boolean') {
            optionCost = fieldDef?.extended_options?.[String(currentValues[key])]?.cost;
        } else if (type === 'FLOAT' || type === 'INT') {
            // FLOAT/INT: cost rate multiplied by the current value
            if (typeof fieldDef.cost === 'number') {
                const currentVal = Number(currentValues[key]);
                if (!isNaN(currentVal)) {
                    optionCost = currentVal * fieldDef.cost;
                }
            }
        }

        if (typeof optionCost === 'number') costValues.push(optionCost);
    }
    if (costValues.length === 0) return 0;
    return costValues.reduce((product, val) => product * val, 1);
}
